import React from 'react'
import clsx from 'clsx'
import { VolumeHigh, Document } from 'iconsax-react'
import { useTheme } from '@mui/material'

import Menu from '../Menu'
import MediaViewerModal from '../../../ChatModals/MediaViewerModal'
import OverflowText from '../../../../atoms/OverflowText'

import useStyles from './styles'

const Other = ({ media, isYours }) => {
  const theme = useTheme()

  const [hovering, setHovering] = React.useState(false)
  const [modalOpen, setModalOpen] = React.useState(false)

  const Icon = React.useMemo(() => {
    const type = media.mime ?? ''
    if (type.startsWith('audio')) {
      return props => (
        <VolumeHigh
          size={theme.size.xl}
          variant='Bold'
          color={'#B64FCD'}
          {...props}
        />
      )
    } else {
      return props => (
        <Document
          size={theme.size.xl}
          variant='Bold'
          color={'#B64FCD'}
          {...props}
        />
      )
    }
  }, [media.mime, theme.size.xl])

  const type = React.useMemo(() => {
    const type = media.mime ?? ''

    if (type.includes('/')) {
      const types = type.split('/')
      const typeText = types[1] ?? ''
      if (
        typeText.includes('pdf') ||
        typeText.includes('zip') ||
        typeText.includes('jpeg') ||
        typeText.includes('jpg') ||
        typeText.includes('gif') ||
        typeText.includes('audio')
      )
        return typeText.toLocaleUpperCase()
    }

    return 'FILE'
  }, [media.mime])

  const classes = useStyles({ isYours })

  const handleOpenFile = React.useCallback(() => {
    setModalOpen(true)
  }, [])

  return (
    <div
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
      className={classes.root}
    >
      <div className={classes.content}>
        <div className={classes.icon}>
          <Icon />
        </div>

        <div className={classes.info}>
          <OverflowText className={classes.title}>
            {media.filename}
          </OverflowText>

          <OverflowText className={clsx(classes.title, classes.type)}>
            {type}
          </OverflowText>
        </div>
        {hovering && (
          <Menu
            isYours={isYours}
            file={media}
            onOpenFileClick={handleOpenFile}
          />
        )}
      </div>
      {modalOpen && (
        <MediaViewerModal
          file={modalOpen ? media : null}
          onClose={() => setModalOpen(false)}
        />
      )}
    </div>
  )
}

export default Other
